import { t } from 'i18next'
import { ApprovedStatus } from '../reservation-approved-status'
import { GuestRoomSelectableResponseType } from '../room-manager/response/guest-room-selectable'

export type GuestRoomAssignResponseType = {
  rooms: ({
    guestRoomAssignId: string
    guestRoomAssignShortId: string
    assignStatus: ApprovedStatus | 'preparation'
    assignGuestName?: string | null
    assignCheckinDate: string | null
    assignCheckoutDate: string | null
    checkinTime?: string | null
    lastCheckinDatetime?: string
    checkoutTime?: string | null
    guestRoomId: string | null
    roomNumber: string | null
    keyNumber: string | null
    roomTypeId: string | null
    typeNameJa: string | null
    typeNameEn: string | null
    reservationId: string | null
    reservationUserName: string | null
    reservationGuestName?: string | null
    salesOfficeCompanyCodeId?: string | null
    isNetSales?: number | null
    reservationCheckinDate?: string | null
    reservationCheckoutDate?: string | null
    checkinId?: string | null
    isRepresentative?: number | null
    accessGuestId?: string | null
    issueType?: string | null
    // 対面発行の発行回数（再発行ごとに増える）。プラスモードの施設では美和アプリへ送る
    issueCount?: number
    // カードキー発行枚数の初期値（固定枚数の設定、なければ大人の人数から算出）
    requiredCardCount: number
    selectableRooms?: GuestRoomSelectableResponseType['guestRooms']
    editingId?: string
    preparationMemo?: string
    preparationType?: number
    qrCode?: string | null
  } & PaxFullObject)[]
}

export type PaxFullObject = {
  paxChildA?: string | number
  paxChildB?: string | number
  paxChildC?: string | number
  paxChildD?: string | number
  paxChildE?: string | number
  paxChildF?: string | number
  paxChildOther?: string | number
  paxFemale?: string | number
  paxMale?: string | number
  pax?: string | number
}

export const GuestRoomAssignType = {
  all: t('All'),
  assigned: t('Assigned'),
  notAssigned: t('Not assigned'),
}

export enum AssignOrders {
  ascending = 'asc',
  descending = 'desc',
}
export enum VacancyPeriods {
  longFirst = 'long',
  shortFirst = 'short',
}
export enum FloorSettings {
  same = 'same',
  differentPossible = 'different_possible',
}
export enum Priorities {
  assignOrder = 'assignOrder',
  vacancyPeriod = 'vacancyPeriod',
}

export type GuestRoomAutoAssignConfig = {
  assignOrder: AssignOrders
  vacancyPeriod: VacancyPeriods
  floorSetting: FloorSettings
  timingOfImportReservation: boolean
  timingOfDatetime: boolean
  timingOfDatetimeSetting: {
    day: number | undefined
    time: string | undefined
  }
  timingOfSelfCheckIn: boolean
  timingOfStayAtPms: boolean
  priorities: Array<Priorities>
}
